import * as React from "react";
import styled from "styled-components";
import { Menu } from "components/bootstrap";
const Trigger = styled.div`
  display: inline-block;
  cursor: pointer;
`;
const DropdownMenu = ({
  trigger,
  position = "bottom-start",
  children,
  onClose = () => {
  },
  closeOnItemClick = true
}) => /* @__PURE__ */ React.createElement(Menu, { position, onClose, closeOnItemClick, withinPortal: true }, /* @__PURE__ */ React.createElement(Menu.Target, null, /* @__PURE__ */ React.createElement(Trigger, null, trigger)), /* @__PURE__ */ React.createElement(Menu.Dropdown, null, children));
export default DropdownMenu;
